import React from "react";
import Man from "./Man";

const Video = ( {data} ) => {
    return(
        <div className="flex flex-col md:p-5 p-3 lg:gap-32 md:gap-24 gap-16">

            <div className="flex flex-col items-center gap-8">

                <span className="lg:text-[40px] sm:text-[36px] text-center text-balance text-[28px] font-medium" style={{color: data.title_color}}>{data.title}</span>

                <video className="rounded-3xl sm:aspect-auto aspect-[1/2] w-full" src={data.url_video} controls > 

                </video>
            </div>
        
            <Man data ={data}/>
        </div>
    );
};

export default Video;